import React from 'react'
import { displayDollar, displayStatus } from '../../../lib/utils/helpers'
import { withUpperScaleSuffix } from '../dashboard-v2.utils'

type ProfileCardProps = {
  investorInitial: string
  investorDisplayName: string
  kycStatus?: string
  clientId?: string
  totalInvestment: number
  investmentLimit: number
  usedPct: number
  remaining: number
  activeHoldings: number
  onRequestLimitExtension: () => void
  hasPendingLimitRequest?: boolean
  onWallet: () => void
}

export const ProfileCard: React.FC<ProfileCardProps> = ({
  investorInitial,
  investorDisplayName,
  kycStatus,
  clientId,
  totalInvestment,
  investmentLimit,
  usedPct,
  remaining,
  activeHoldings,
  onRequestLimitExtension,
  hasPendingLimitRequest = false,
  onWallet,
}) => {
  return (
    <article className='dashboard-v2__profile-card'>
      <div className='profile-row'>
        <div className='avatar'>{investorInitial}</div>
        <div>
          <span className='muted'>Client</span>
          <h3>{investorDisplayName}</h3>
          {clientId ? <h5>Client ID: {clientId}</h5> : null}
          <span className='status chip chip--success'>
            {kycStatus ? displayStatus(kycStatus) : 'KYC'}
          </span>
        </div>
      </div>

      <div className='limit-row'>
        <span>Investment Limit</span>
        <strong>
          {withUpperScaleSuffix(displayDollar(String(totalInvestment), 'USD', 2, false))} /{' '}
          {withUpperScaleSuffix(displayDollar(String(investmentLimit), 'USD', 2, false))}
        </strong>
      </div>
      <div className='progress'>
        <div style={{ width: `${usedPct}%` }} />
      </div>

      <div className='progress-meta'>
        <div>
          <small>Used</small>
          <strong>
            {withUpperScaleSuffix(displayDollar(String(totalInvestment), 'USD', 2, false))}
          </strong>
        </div>
        <div>
          <small>Remaining</small>
          <strong>{withUpperScaleSuffix(displayDollar(String(remaining), 'USD', 2, false))}</strong>
        </div>
        <div>
          <small>Utilization</small>
          <strong>{usedPct.toFixed(2)}%</strong>
        </div>
        <div>
          <small>Active Holdings</small>
          <strong>{activeHoldings}</strong>
        </div>
      </div>
      <div className='profile-card__limit-actions'>
        <button
          type='button'
          className='secondary small limit-extension-cta'
          onClick={onRequestLimitExtension}
          disabled={hasPendingLimitRequest}
          data-testid='limit-extension-cta'
        >
          {hasPendingLimitRequest
            ? 'Request under review'
            : 'Place a request to increase the Investment Limit'}
        </button>
        <button type='button' className='small' onClick={onWallet}>
          Wallet
        </button>
      </div>
    </article>
  )
}
